import {Button, Card, Form} from "react-bootstrap";
import React, {useState} from "react";
import { useForm } from "react-hook-form";
import {Navigate} from "react-router-dom";
import axios from "axios";

function ForgotPassword(){
    const { register, handleSubmit, reset } = useForm();
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    function submit(e) {
        setIsSubmitting(true);
        setError('');
        setSuccess('');
        
        let bodyFormData = new FormData();
        bodyFormData.append("identifier", e.identifier);

        axios.post("/auth/forgot-password", bodyFormData, {
            headers: {'content-type': 'application/x-www-form-urlencoded'}
        })
        .then(() => {
            setSuccess("Password reset email sent! Please check your email for further instructions.");
            reset();
        })
        .catch(err => {
            console.log(err);
            if (err.response?.data?.message) {
                setError(err.response.data.message);
            } else {
                setError("Error sending reset email. Please try again.");
            }
        })
        .finally(() => {
            setIsSubmitting(false);
        });
    }

    return (
        <>
            <Card.Title>Forgot Password</Card.Title>
            <p className="text-muted mb-3">
                Enter your email address or student number and we'll send you a link to reset your password.
            </p>
            <Form onSubmit={handleSubmit(submit)}>
                {error && <label style={{color: "red"}}>{error}</label>}
                {success && <label style={{color: "green"}}>{success}</label>}
                <Form.Group className="mb-3" controlId="formIdentifier">
                    <Form.Label>Email or Student Number</Form.Label>
                    <Form.Control 
                        {...register("identifier", { required: true })} 
                        type="text" 
                        placeholder="Enter your email or student number" 
                        disabled={isSubmitting}
                    />
                </Form.Group>
                <div className="d-grid gap-2">
                    <Button 
                        variant="primary" 
                        type="submit" 
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Sending...' : 'Send Reset Link'}
                    </Button>
                    <Button 
                        variant="outline-secondary" 
                        onClick={() => window.location.href = '/login'}
                        disabled={isSubmitting}
                    >
                        Back to Login
                    </Button>
                </div>
            </Form>
        </>
    )
}

export default ForgotPassword;